<template>
  <div class="news-card-details-wrapper d-flex">
    <div class="date-text pr-3">{{ getDateStr(date) }}</div>
    <div class="tag">
      <!-- <i class="tag-text">{{ tag }}</i> -->
      <div class="tag-underline"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "news-card-details",
  props: ["date", "tag"],
  methods: {
    getDateStr(date) {
      let dateStrFormat = "MMM D YYYY";
      return moment.utc(date).format(dateStrFormat).toUpperCase();
    }
  }
};
</script>

<style scoped>
.news-card-details-wrapper {
  color: #666666;
  font-weight: 600;
}
.tag {
  margin-top: -3px;
}
.tag-text {
  font-family: artifaktElementBold;
  font-size: 12px;
}
.tag-underline {
  height: 2px;
  background: #abe1a6;
  margin-top: -3px;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/news/NewsCardDetails.vue